module.exports = __webpack_public_path__ + "static/media/43.3c328869.JPG";